import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
export var PauseOutlineSVG = function PauseOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M12 25h-2a2 2 0 01-2-2V9a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2zM10 9v14h2V9zM22 25h-2a2 2 0 01-2-2V9a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2zM20 9v14h2V9z"
  }));
};
PauseOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(PauseOutlineSVG);